const icecatLanguages = {
    'icecat.languages.en': 'English',
    'icecat.languages.nl': 'Dutch',
    'icecat.languages.fr': 'French',
    'icecat.languages.de': 'German',
    'icecat.languages.it': 'Italian',
    'icecat.languages.es': 'Spanish',
    'icecat.languages.dk': 'Danish',
    'icecat.languages.ru': 'Russian',
    'icecat.languages.us': 'US English',
    'icecat.languages.br': 'Brazilian-Portuguese',
    'icecat.languages.pt': 'Portuguese-Portuguese',
    'icecat.languages.zh': 'Simplified Chinese',
    'icecat.languages.sv': 'Swedish',
    'icecat.languages.pl': 'Polish',
    'icecat.languages.cz': 'Czech',
    'icecat.languages.hu': 'Hungarian',
    'icecat.languages.fi': 'Finnish',
    'icecat.languages.el': 'Greek',
    'icecat.languages.no': 'Norwegian',
    'icecat.languages.tr': 'Turkish',
    'icecat.languages.bg': 'Bulgarian',
    'icecat.languages.ka': 'Georgian',
    'icecat.languages.ro': 'Romanian',
    'icecat.languages.sr': 'Serbian',
    'icecat.languages.uk': 'Ukrainian',
    'icecat.languages.ja': 'Japanese',
    'icecat.languages.ca': 'Catalan',
    'icecat.languages.es_ar': 'Argentinian-Spanish',
    'icecat.languages.hr': 'Croatian',
    'icecat.languages.ar': 'Arabic',
    'icecat.languages.vi': 'Vietnamese',
    'icecat.languages.ko': 'Korean',
    'icecat.languages.mk': 'Macedonian',
    'icecat.languages.sl': 'Slovenian',
    'icecat.languages.en_sg': 'Singapore English',
    'icecat.languages.en_za': 'South Africa English',
    'icecat.languages.zh_tw': 'Traditional Chinese',
    'icecat.languages.he': 'Hebrew',
    'icecat.languages.lt': 'Lithuanian',
    'icecat.languages.lv': 'Latvian',
    'icecat.languages.en_in': 'Indian English',
    'icecat.languages.de_ch': 'Swiss German',
    'icecat.languages.id': 'Indonesian',
    'icecat.languages.sk': 'Slovenčina',
    'icecat.languages.fa': 'Persian',
    'icecat.languages.ex_mx': 'Mexican Spanish',
    'icecat.languages.et': 'Estonian',
    'icecat.languages.de_be': 'German (BE)',
    'icecat.languages.fr_be': 'Wallon',
    'icecat.languages.nl_be': 'Vlaams',
    'icecat.languages.th': 'ภาษาไทย',
};

export default icecatLanguages;
